/* jshint undef: true, unused: true */
/* globals require */

var notJquery = require('../not-jquery'),
    FoBuComponentFactory = require('./fobu-component-factory');


module.exports = function component (componentSettings, foBu) {

  var nJ               = notJquery,
      componentFactory = new FoBuComponentFactory(componentSettings, foBu),
      componentObject  = componentFactory.getComponentObject(),
      wrapper          = componentObject.wrapper,
      label            = componentObject.label;




  Object.keys(componentSettings.inputChildren).map(function(key) {
    componentSettings.inputChildren[key].isChildComponent = true;
    var child = foBu.createItem(componentSettings.inputChildren[key]);

    if (label) {
      nJ.addClass(label, 'foBu__column');
    }

    wrapper.appendChild(child);
  });


  return {
    wrapper           : wrapper,
    finaliseComponent : componentFactory.finaliseComponent
  };
};
